// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grow[data-v-30954ff4] {\n  position: relative;\n}\n.w-drawer-item > .icon[data-v-30954ff4] {\n  margin-right: 10px;\n  font-size: 16px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
